"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Filter = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M9.333 14.44c0-.71-.282-1.392-.786-1.893l-7.76-7.76A2.667 2.667 0 010 2.893v-1.56C0 .597.597 0 1.333 0h21.334C23.403 0 24 .597 24 1.333v1.56c0 .711-.283 1.393-.787 1.894l-7.76 7.76a2.667 2.667 0 00-.786 1.893v4.893c0 .84-.396 1.63-1.067 2.134l-3.2 2.4a.667.667 0 01-1.067-.534V14.44z" })); };
exports.Filter = Filter;
//# sourceMappingURL=filter.js.map